import { Table } from 'antd';
import React, { FC } from 'react';
import classNames from 'classnames';
import { SelectedColumnWithArgs, TableColumnCreator, useTableColumns } from '../../../../hooks/table/useTableColumns/useTableColumns';
import { BGSummaryTableColumns } from './BGSummaryTableColumns';
import { BGSummaryKey } from '../../type';
import '../vitalsTable.scss';

export interface BGSummaryTableData {
  type: BGSummaryKey;
  count: number;
  average: number[];
  range: number[];
  inRangePercentage: number;
}

export interface BGSummaryTableComponentProps {
  data: Partial<BGSummaryTableData>[];
  totalCount?: number;
}

export const BGSummaryTableComponent: FC<BGSummaryTableComponentProps> = ({
  data,
  totalCount,
}) => {
  const columns = useTableColumns(
    BGSummaryTableColumns,
    [
      'type',
      { name: 'count', args: [totalCount] } as SelectedColumnWithArgs<TableColumnCreator<BGSummaryTableData>, 'count'>,
      'average',
      'range',
      'inRangePercentage'
    ],
    [totalCount]
  );

  return (
    <Table
      className={classNames({
        'summary-table': true,
        'vitals-un-bordered-table': true,
      })}
      dataSource={data}
      columns={columns}
      pagination={false}
      rowKey={(v) => v.type}
    />
  );
};
